import type { FC } from 'react';
import { useSampleTrackers } from '../../../lib/customHooks';
import { useStore } from '../../../store/reducers';
import { NoDataPlaceholder } from '../../Prediction/NoDataPlaceholder';
import { TrackerTable } from './TrackerTable';

const SELECTION_ID = 'sample';

export const SampleTrackerTable: FC = () => {
  const sampleTrackers = useSampleTrackers();
  const selectedTrackerIds = useStore((s) => s.trackers.selectedTrackerIds[SELECTION_ID]);
  const { updateCompleteSelection: updateCompleSelection } = useStore((s) => s.trackers.actions);

  return (
    <TrackerTable
      trackers={sampleTrackers}
      noDataPlaceholder={<NoTrackerPlaceholder />}
      selectedTrackerIds={selectedTrackerIds}
      onSelectionChange={(ids) => updateCompleSelection(ids, SELECTION_ID)}
      dragElementType="sample-trackers"
    />
  );
};

const NoTrackerPlaceholder = () => {
  return (
    <NoDataPlaceholder
      title="No Tracker"
      subtitle="Add tracker per drag and drop from bottom table!"
    />
  );
};
